import React from 'react';
import LogoSpinner from '../components/ui/LogoSpinner';

// Kept for the pages that still import it; every use is a whole-page wait.
const LoadingIcon = () => <LogoSpinner />;

export default LoadingIcon;
